import React from 'react';
import PropTypes from 'prop-types';

import { InfoIcon } from 'common/icons';
import Tooltip from '../Tooltip';

import { staticStyles } from './style';

const InfoTooltip = ({ id, text }) => (
  <div className="InfoTooltip">
    <Tooltip id={id} textId={text} textExtraclass="InfoTooltip__content" noTranslate isHTML clickable>
      <InfoIcon />
      <style jsx global>
        {staticStyles}
      </style>
    </Tooltip>
  </div>
);

InfoTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default InfoTooltip;
